module.exports = __webpack_public_path__ + "static/media/product-logo-3.34bcf391.svg";